import React from "react";
import styled from 'styled-components';


const Wrapper  = styled.div.withConfig({displayName:'-Wrapper '})`
  display: inline-block;
  position: relative;

  &:hover > * {
    display: block;
  }
`;
const Trigger  = styled.div.withConfig({displayName:'-Trigger '})`
  display: inline-block;
  position: relative;
`;
const TableWrapper  = styled.table.withConfig({displayName:'-TableWrapper '})`
  position: absolute;
  top: -14px;
  right: 20px;
  border: 2px solid #C4C4C4;
  background-color: #ffffff;
  color: #000000;
  display: none;
  border-radius: 3px;
  z-index: 999;
`;
const THead = styled.thead`
  & th{
    font-size: 11px;
    color: #C4C4C4;
    font-weight: normal;
    white-space: nowrap;
    padding: 3px 6px;
    border-bottom: 1px solid #C4C4C4;
    text-align: center;
  }
`;
const TBody = styled.tbody`
  & td{
    font-size: 11px;
    padding: 3px 6px;
    text-align: center;
    font-weight: 400;
    text-align: center;
    white-space: normal;
  }
`;

const InfoTable = ({
    columns = [],
    values = []
  }) => {
  return (
    <Wrapper>
      <Trigger><i className="fa-solid fa-circle-info"></i></Trigger>
      <TableWrapper>
        <THead>
          <tr>
            {columns.map((item, i) =>
              <th key={i}>
                {item}
              </th>
            )}
          </tr>
        </THead>
        <TBody>
          {values.map((row, i) => {
            return (<tr
              key={i}
            >
              {row.map((item, j) =>
                <td key={j} label={columns[j]}>
                  {item}
                </td>
              )}
            </tr>);
          })}
        </TBody>
      </TableWrapper>
    </Wrapper>
  )
}

export default InfoTable;
